// extracted by mini-css-extract-plugin
module.exports = {"countdown":"BlackFridayCountdown-module__countdown___1-Io5"};